
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { PingRequest, PingResponseBody } from '../entities/ping-commands-v2/models';
import { axiosInstance } from "../axios-instance";

class PingConfig {
  private authClient: OAuth2Client | null;

  private baseUrlV2: string;

  constructor(authClient: OAuth2Client | null, baseUrlV2: string) {
    this.authClient = authClient;
    this.baseUrlV2 = baseUrlV2;
  }

  pingCommandToDevice(input: PingRequest): Promise<AxiosResponse<PingResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<PingResponseBody>(`${this.baseUrlV2}/queuePingCommands`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default PingConfig;
